export const FETCH_SUBSCRIPTIONS_REQUEST = 'FETCH_SUBSCRIPTIONS_REQUEST';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_FAILED = 'FETCH_SUBSCRIPTIONS_FAILED';

export const FETCH_SUBSCRIPTION_BY_ID_REQUEST = 'FETCH_SUBSCRIPTION_BY_ID_REQUEST';
export const FETCH_SUBSCRIPTION_BY_ID_SUCCESS = 'FETCH_SUBSCRIPTION_BY_ID_SUCCESS';
export const FETCH_SUBSCRIPTION_BY_ID_FAILED = 'FETCH_SUBSCRIPTION_BY_ID_FAILED';

export const FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_REQUEST =
  'FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_REQUEST';
export const FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_SUCCESS =
  'FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_SUCCESS';
export const FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_FAILED =
  'FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_FAILED';

export const FETCH_CHANGE_VEHICLE_REQUEST = 'FETCH_CHANGE_VEHICLE_REQUEST';
export const FETCH_CHANGE_VEHICLE_SUCCESS = 'FETCH_CHANGE_VEHICLE_SUCCESS';
export const FETCH_CHANGE_VEHICLE_FAILED = 'FETCH_CHANGE_VEHICLE_FAILED';

export const FETCH_CANCEL_SUBSCRIPTION_REQUEST = 'FETCH_CANCEL_SUBSCRIPTION_REQUEST';
export const FETCH_CANCEL_SUBSCRIPTION_SUCCESS = 'FETCH_CANCEL_SUBSCRIPTION_SUCCESS';
export const FETCH_CANCEL_SUBSCRIPTION_FAILED = 'FETCH_CANCEL_SUBSCRIPTION_FAILED';

export const RESET_CHANGE_VEHICLE_SUCCESS = 'RESET_CHANGE_VEHICLE_SUCCESS';

export const FETCH_SUBSCRIPTIONS_PERIODS_REQUEST = 'FETCH_SUBSCRIPTIONS_PERIODS_REQUEST';
export const FETCH_SUBSCRIPTIONS_PERIODS_SUCCESS = 'FETCH_SUBSCRIPTIONS_PERIODS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_PERIODS_FAILED = 'FETCH_SUBSCRIPTIONS_PERIODS_FAILED';

export const FETCH_UPDATE_EXCHANGE_REQUEST = 'FETCH_UPDATE_EXCHANGE_REQUEST';
export const FETCH_UPDATE_EXCHANGE_SUCCESS = 'FETCH_UPDATE_EXCHANGE_SUCCESS';
export const FETCH_UPDATE_EXCHANGE_FAILED = 'FETCH_UPDATE_EXCHANGE_FAILED';

export const FETCH_UPDATE_SUBSCRIPTION_REQUEST = 'FETCH_UPDATE_SUBSCRIPTION_REQUEST';
export const FETCH_UPDATE_SUBSCRIPTION_SUCCESS = 'FETCH_UPDATE_SUBSCRIPTION_SUCCESS';
export const FETCH_UPDATE_SUBSCRIPTION_FAILED = 'FETCH_UPDATE_SUBSCRIPTION_FAILED';

export const RESET_SUBSCRIPTION_SUCCESS = 'RESET_SUBSCRIPTION_SUCCESS';

export const RESET_UPDATE_SUBSCRIPTION_SUCCESS = 'RESET_UPDATE_SUBSCRIPTION_SUCCESS';

export const RESET_CANCEL_SUBSCRIPTION_SUCCESS = 'RESET_CANCEL_SUBSCRIPTION_SUCCESS';

export const RESET_EXCHANGE_SUBSCRIPTION_SUCCESS = 'RESET_EXCHANGE_SUBSCRIPTION_SUCCESS';

export const FETCH_SUBSCRIPTION_PRICING_REQUEST = 'FETCH_SUBSCRIPTION_PRICING_REQUEST';
export const FETCH_SUBSCRIPTION_PRICING_SUCCESS = 'FETCH_SUBSCRIPTION_PRICING_SUCCESS';
export const FETCH_SUBSCRIPTION_PRICING_FAILED = 'FETCH_SUBSCRIPTION_PRICING_FAILED';

export const FETCH_VEHICLE_GROUPS_AGGREGATES_REQUEST = 'FETCH_VEHICLE_GROUPS_AGGREGATES_REQUEST';
export const FETCH_VEHICLE_GROUPS_AGGREGATES_SUCCESS = 'FETCH_VEHICLE_GROUPS_AGGREGATES_SUCCESS';
export const FETCH_VEHICLE_GROUPS_AGGREGATES_FAILED = 'FETCH_VEHICLE_GROUPS_AGGREGATES_FAILED';

export const FETCH_AGGREGATES_TOTALS_REQUEST = 'FETCH_AGGREGATES_TOTALS_REQUEST';
export const FETCH_AGGREGATES_TOTALS_SUCCESS = 'FETCH_AGGREGATES_TOTALS_SUCCESS';
export const FETCH_AGGREGATES_TOTALS_FAILED = 'FETCH_AGGREGATES_TOTALS_FAILED';
